import { render, staticRenderFns } from "./importAppRules.vue?vue&type=template&id=db8af740&scoped=true&"
import script from "./importAppRules.vue?vue&type=script&lang=ts&"
export * from "./importAppRules.vue?vue&type=script&lang=ts&"
import style0 from "./importAppRules.vue?vue&type=style&index=0&id=db8af740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8af740",
  null
  
)

export default component.exports